import React from "react";
import Approval from "../Approval/Approval";

const PaymentApprovals = () => {
  return <Approval defaultTab="payment" />;
};

export default PaymentApprovals;
